import React, { useState } from 'react';
import { Menu, X, Zap } from 'lucide-react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

export default function MobileHeader() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
    setIsMenuOpen(false);
  };

  return (
    <>
      <header className="fixed top-0 left-0 right-0 bg-white border-b border-gray-100 z-50">
        <div className="px-4 py-3 flex items-center justify-between">
          <Link to="/dashboard" className="flex items-center">
            <div className="w-8 h-8 rounded-lg bg-indigo-100 flex items-center justify-center">
              <Zap className="h-5 w-5 text-indigo-600" />
            </div>
            <span className="ml-2 text-xl font-bold text-gray-900">Kontty</span>
          </Link>
          
          <button
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            className="p-2 text-gray-600 hover:text-gray-900"
          >
            {isMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>

        {/* Mobile Menu Dropdown */}
        {isMenuOpen && (
          <div className="absolute top-full left-0 right-0 bg-white border-b border-gray-100 shadow-lg z-50">
            <div className="py-2 px-4">
              <Link 
                to="/dashboard" 
                className="block py-2 text-gray-700 hover:text-indigo-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Início
              </Link>
              <Link 
                to="/dashboard/ideias" 
                className="block py-2 text-gray-700 hover:text-indigo-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Ideias de Conteúdo
              </Link>
              <Link 
                to="/dashboard/calendario" 
                className="block py-2 text-gray-700 hover:text-indigo-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Calendário
              </Link>
              <Link 
                to="/dashboard/analises" 
                className="block py-2 text-gray-700 hover:text-indigo-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Análises
              </Link>
              <Link 
                to="/dashboard/planos" 
                className="block py-2 text-gray-700 hover:text-indigo-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Meus Planos
              </Link>
              <Link 
                to="/dashboard/precos" 
                className="block py-2 text-gray-700 hover:text-indigo-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Preços
              </Link>
              <Link 
                to="/dashboard/configuracoes" 
                className="block py-2 text-gray-700 hover:text-indigo-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Configurações
              </Link>
              <Link 
                to="/dashboard/ajuda" 
                className="block py-2 text-gray-700 hover:text-indigo-600"
                onClick={() => setIsMenuOpen(false)}
              >
                Ajuda
              </Link>
              <button
                onClick={handleLogout}
                className="block w-full text-left py-2 text-red-600 hover:text-red-700"
              >
                Sair
              </button>
            </div>
          </div>
        )}
      </header>
    </>
  );
}